import { cn } from '@ui/lib/utils.js';
import { cva, type VariantProps } from 'class-variance-authority';

export { default as PTooltip } from './PTooltip.vue';
export { default as PTooltipContent } from './PTooltipContent.vue';
export { default as PTooltipProvider } from './PTooltipProvider.vue';
export { default as PTooltipTrigger } from './PTooltipTrigger.vue';

export const pTooltipContentCva = cva(
    cn(
        'animate-in',
        'duration-100',
        'fade-in-0',
        'zoom-in-95',
        'data-[state=closed]:animate-out',
        'data-[state=closed]:fade-out-0',
        'data-[state=closed]:zoom-out-95',
        'data-[side=bottom]:slide-in-from-top-2',
        'data-[side=left]:slide-in-from-right-2',
        'data-[side=right]:slide-in-from-left-2',
        'data-[side=top]:slide-in-from-bottom-2',
        'z-50',
        'w-fit',
    ),
    {
        variants: {
            variant: {
                default: cn(
                    'paragraph-xs',
                    'text-balance',
                    'px-2',
                    'py-1.5',
                    'rounded-lg',
                    'bg-popover-popover',
                    'text-popover-popover-foreground',
                ),
                unstyled: '',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

export type PTooltipContentVariants = VariantProps<typeof pTooltipContentCva>;
